var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconDualtoneContact48 = function SvgAIconDualtoneContact48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14613_256)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2667 39.8H26.1333L15.2 48V39.8H9.73333C8.22375 39.8 7 38.5762 7 37.0667V9.73333C7 8.22375 8.22375 7 9.73333 7H45.2667C46.7762 7 48 8.22375 48 9.73333V37.0667C48 38.5762 46.7762 39.8 45.2667 39.8Z",
    fill: "#DCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2667 33.8H20.1333L9.2 42V33.8H3.73333C2.22375 33.8 1 32.5762 1 31.0667V3.73333C1 2.22375 2.22375 1 3.73333 1H39.2667C40.7762 1 42 2.22375 42 3.73333V31.0667C42 32.5762 40.7762 33.8 39.2667 33.8Z",
    stroke: "#2C5A82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88477 24.6538H27.8078",
    stroke: "#2C5A82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88477 18.3462H34.1155",
    stroke: "#2C5A82",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14613_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.0002,
    height: 48,
    fill: "white"
  })))));
};
export { SvgAIconDualtoneContact48 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0NjEzXzI1NikiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQ1LjI2NjcgMzkuOEgyNi4xMzMzTDE1LjIgNDhWMzkuOEg5LjczMzMzQzguMjIzNzUgMzkuOCA3IDM4LjU3NjIgNyAzNy4wNjY3VjkuNzMzMzNDNyA4LjIyMzc1IDguMjIzNzUgNyA5LjczMzMzIDdINDUuMjY2N0M0Ni43NzYyIDcgNDggOC4yMjM3NSA0OCA5LjczMzMzVjM3LjA2NjdDNDggMzguNTc2MiA0Ni43NzYyIDM5LjggNDUuMjY2NyAzOS44WiIgZmlsbD0iI0RDRUNGQSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM5LjI2NjcgMzMuOEgyMC4xMzMzTDkuMiA0MlYzMy44SDMuNzMzMzNDMi4yMjM3NSAzMy44IDEgMzIuNTc2MiAxIDMxLjA2NjdWMy43MzMzM0MxIDIuMjIzNzUgMi4yMjM3NSAxIDMuNzMzMzMgMUgzOS4yNjY3QzQwLjc3NjIgMSA0MiAyLjIyMzc1IDQyIDMuNzMzMzNWMzEuMDY2N0M0MiAzMi41NzYyIDQwLjc3NjIgMzMuOCAzOS4yNjY3IDMzLjhaIiBzdHJva2U9IiMyQzVBODIiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguODg0NzcgMjQuNjUzOEgyNy44MDc4IiBzdHJva2U9IiMyQzVBODIiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguODg0NzcgMTguMzQ2MkgzNC4xMTU1IiBzdHJva2U9IiMyQzVBODIiIHN0cm9rZS13aWR0aD0iMS44IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xNDYxM18yNTYiPgo8cmVjdCB3aWR0aD0iNDguMDAwMiIgaGVpZ2h0PSI0OCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";